// extracted by mini-css-extract-plugin
export default {"container":"dayName_container__y0Eri","arrow":"dayName_arrow__z-qOH"};